import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';
import { PATH_DEFINITIONS } from '../../definitions/path-definition';

@Injectable({
  providedIn: 'root'
})
export class PermissionGuard implements CanActivate {
  constructor(
    private store: Store<any>,
    private router: Router
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const requiredPermissions = route.data?.requiredPermissions as string[];

    if (!requiredPermissions || requiredPermissions.length === 0) {
      return true;
    }

    return this.store.select(state => state.auth?.permissions)
      .pipe(
        filter(permissions => permissions !== undefined),
        take(1),
        switchMap(permissions => {
          const hasPermission = requiredPermissions.some(permission =>
            Array.isArray(permissions) && permissions.includes(permission)
          );

          if (hasPermission) {
            return of(true);
          } else {
            return of(this.router.parseUrl(PATH_DEFINITIONS.PROJECTS.PROJECT_LIST_PATH));
          }
        })
      );
  }
}
